module.exports = "<div><kt-flight-route data-flight=flight></kt-flight-route></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/trip/directives/templates/flightRouteTooltip.tmpl.html
// module id = 3705
// module chunks = 0